import React from 'react';

import AnnotationName from '../shared/AnnotationName';
import Instruction from '../shared/Instruction';
import WrittenText from './WrittenText';

const MLDataCollection = ({ animate }) => (
  <div className="h-full rounded-lg overflow-hidden flex flex-col">
    <AnnotationName icon="collection" name="ML Data Collection" />
    <Instruction
      icon="ask"
      instruction="Ask to schedule a demo for the company's new phone product."
    />
    {animate && <WrittenText />}
  </div>
);

export default MLDataCollection;
